import React from "react";
import { useNavigate } from "react-router-dom";
import BadgeStatus from "./BadgeStatus";
import ApiImage from "./ApiImage";
import "./scss/seller-order-card.scss";

const MAX_VISIBLE_IMAGES = 3;

export default function SellerOrderCard({ order }) {
  const navigate = useNavigate();

  const visibleImages = order.images.slice(0, MAX_VISIBLE_IMAGES);
  const hiddenCount =
    order.productCount > MAX_VISIBLE_IMAGES
      ? order.productCount - MAX_VISIBLE_IMAGES
      : 0;

  const getProductWord = (count) => {
    if (count % 10 === 1 && count % 100 !== 11) return "товар";
    if (
      count % 10 >= 2 &&
      count % 10 <= 4 &&
      (count % 100 < 10 || count % 100 >= 20)
    )
      return "товара";
    return "товаров";
  };

  return (
    <div
      className="seller-order-card"
      onClick={() => navigate(`/seller/order/info/${order.id}`)}
    >
      <div className="seller-order-card__top">
        <BadgeStatus status={order.status} />
        <div className="seller-order-card__number">
          {order.orderNumber}
        </div>
      </div>

      <div className="seller-order-card__title">
        Заказ от {order.date}
      </div>

      <div className="seller-order-card__meta">
        {order.productCount} {getProductWord(order.productCount)} ·{" "}
        {order.price.toLocaleString("ru-RU")} ₽
      </div>

      <div className="seller-order-card__images">
        {visibleImages.map((img, i) => (
          <div key={i} className="seller-order-card__image">
            <ApiImage src={img} />
          </div>
        ))}

        {hiddenCount > 0 && (
          <div className="seller-order-card__more">
            +{hiddenCount}
          </div>
        )}
      </div>
    </div>
  );
}
